let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fZSN3")).then(() => parcelRequire('d6LkT'));